<div class="wrapper">
    <header>
        <h2>{{ title }}</h2>
        <button 
            mat-icon-button 
            aria-label="Close" 
            class="close-button mat-icon-button"
            (click)="onNoClick()"
            type="button"
        >
            <span class="icon-close"></span>
        </button>
    </header>
    <mat-dialog-content>
            <span [innerHTML]="body | safeHtml"></span>
    </mat-dialog-content>

    <mat-dialog-actions>
        <button *ngIf="cancelButton"
            [ngClass]="cancelButton.class" 
            [disabled]="loading" 
            (click)="cancel()"
        >
            {{ cancelButton.text }}
        </button>
        <button *ngIf="confirmButton"
            [ngClass]="confirmButton.class" 
            [disabled]="loading" 
            (click)="confirm()"
        >
            <span *ngIf="!loading">{{ confirmButton.text }}</span>
            <span *ngIf="loading" class="loading-spinner">
                <mat-progress-spinner 
                    mode="indeterminate" 
                    diameter="20"
                ></mat-progress-spinner>
            </span>
        </button>
    </mat-dialog-actions>
</div>
